/* import __COLOCATED_TEMPLATE__ from './blade-transaction-recognition-banner.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { TransactionAuthState } from '@square/dashboard-protos/models/squareup/transaction/transaction_service';
let BladeTransactionRecognitionBanner = (_class = class BladeTransactionRecognitionBanner extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get description() {
    switch (this.args.transactionAuthState) {
      case TransactionAuthState.TRANSACTION_AUTH_RESPONSE_UNSPECIFIED:
        return this.intl.t('banking.checking.unifiedActivity.activityDetails.transactionRecognition.description.initial');
      case TransactionAuthState.TRANSACTION_AUTH_RESPONSE_TRANSACTION_RECOGNIZED:
        return this.intl.t('banking.checking.unifiedActivity.activityDetails.transactionRecognition.description.recognized');
      case TransactionAuthState.TRANSACTION_AUTH_RESPONSE_TRANSACTION_NOT_RECOGNIZED:
        return this.intl.t('banking.checking.unifiedActivity.activityDetails.transactionRecognition.description.notRecognized', {
          link: `/dashboard/transfer/square-card?unitToken=${this.args.unitToken}`,
          htmlSafe: true
        });
      default:
        return null;
    }
  }
  get boldDescription() {
    return this.isUnspecified() ? this.intl.t('banking.checking.unifiedActivity.activityDetails.transactionRecognition.description.boldText') : null;
  }
  get variant() {
    return this.args.transactionAuthState === TransactionAuthState.TRANSACTION_AUTH_RESPONSE_TRANSACTION_RECOGNIZED ? 'info' : 'critical';
  }
  get showButton() {
    return this.isUnspecified();
  }
  recognize() {
    this.args.onRecognizeTransaction(true);
  }
  deny() {
    this.args.onRecognizeTransaction(false);
  }
  isUnspecified() {
    return this.args.transactionAuthState === TransactionAuthState.TRANSACTION_AUTH_RESPONSE_UNSPECIFIED;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "recognize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "recognize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deny", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deny"), _class.prototype), _class);
export { BladeTransactionRecognitionBanner as default };